import { InputLabel, MenuItem, Select } from "@material-ui/core";
import React from "react";
var RoleSelect = function (props) {
    var options = [];
    if (props.allowance === "su") {
        options.push(React.createElement(MenuItem, { key: "admin", value: "admin" }, "Admin"));
    }
    options.push(React.createElement(MenuItem, { key: "agent", value: "agent" }, "Agent"));
    return (React.createElement("div", { className: "col s12 m6" },
        React.createElement(InputLabel, null, "Role"),
        React.createElement(Select, { className: "select", placeholder: "Role", name: "role", onChange: props.onChange, value: props.value, disabled: props.disabled }, options),
        React.createElement("div", { className: "red-text", style: { marginBottom: "20px" } }, props.meta && props.meta.touched && props.meta.error)));
};
export default RoleSelect;



//////////////////
// WEBPACK FOOTER
// ./src/components/common/RoleSelect.tsx
// module id = 560
// module chunks = 0